import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'url': '',
};

export const agencies = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data.map((x) => {
        return {...x,
          'key': `${x.identification}${x.code}`,
          'ruc': x.identification};
      }),
    }),
    [ActionTypes.FETCHED_AGENCIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const provinces = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PROVINCES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PROVINCES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_PROVINCES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const exportAgencies = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.EXPORTING_TO_EXCEL_AGENCIES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EXPORTED_TO_EXCEL_AGENCIES]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.data,
    }),
    [ActionTypes.EXPORTED_TO_EXCEL_AGENCIES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
    [ActionTypes.CLEAN_AGENCIES_EXPORT_URL]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
